var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OnClickOutside',{attrs:{"options":{ ignore: [/* ... */] }},on:{"trigger":_vm.hideEmojiPicker}},[_c('button',{staticClass:"emoji-button",on:{"click":_vm.toggleEmojiPicker}},[_c('img',{attrs:{"src":require("@/assets/emoji.svg"),"alt":"emoji-toggle-button"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }